export enum ProposalState
{
    Creado = 0,
    EnviadoCI = 1,
    DevueltoCI = 2,
    AprobadoCI = 3,
    RechazadoCI = 4,
    EnviadoFC = 5,
    AprobadoFC = 6,
    DevueltoFC = 7,
    RechazadoFC = 8,
    NotificacionFC = 9,
    CerradoFC = 10
}